import { isSuperAdmin } from '@lumapps/permissions';

export const canAccessFeaturesManagement = isSuperAdmin;
